// 采集卡片瀑布流的图片最大高度
export const PIN_CARD_MAX_HEIGHT: number = 520;

export const MATERIAL_CATEGORY = {
  picture: "图片",
  video: "视频",
  miankou: "高端免抠",
  muban: "平面模板",
  shipin: "视频模板",
};

export enum PIN_PRIVATE_STATUS {
  /**公共 */
  PUBLIC,
  /**私有 */
  PRIVATE,
  /**违规 */
  VIOLATION,
}

export enum PIN_APPEAL_STATUS {
  /**审核中 */
  APPEALING,
  /**审核通过 */
  APPEAL_PASS,
  /**未通过 */
  REJECT,
}
